import KanBoUserPickerConnected from './KanBoUserPickerConnected'

export default KanBoUserPickerConnected
